/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchResultDTOFromJSON, SearchResultDTOToJSON, } from './SearchResultDTO';
/**
 * @export
 */
export const SearchResultCatalogDTOStatusEnum = {
    Pending: 'PENDING',
    InQueue: 'IN_QUEUE',
    Processing: 'PROCESSING',
    Success: 'SUCCESS',
    Failed: 'FAILED',
    Canceled: 'CANCELED'
};
/**
 * @export
 */
export const SearchResultCatalogDTOReviewStatusEnum = {
    Pending: 'PENDING',
    Inprogress: 'INPROGRESS',
    Completed: 'COMPLETED',
    Failed: 'FAILED',
    Canceled: 'CANCELED'
};
/**
 * Check if a given object implements the SearchResultCatalogDTO interface.
 */
export function instanceOfSearchResultCatalogDTO(value) {
    return true;
}
export function SearchResultCatalogDTOFromJSON(json) {
    return SearchResultCatalogDTOFromJSONTyped(json, false);
}
export function SearchResultCatalogDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'createdDate': json['createdDate'] == null ? undefined : (new Date(json['createdDate'])),
        'lastModifiedBy': json['lastModifiedBy'] == null ? undefined : json['lastModifiedBy'],
        'lastModifiedDate': json['lastModifiedDate'] == null ? undefined : (new Date(json['lastModifiedDate'])),
        'id': json['id'] == null ? undefined : json['id'],
        'searchResult': json['searchResult'] == null ? undefined : SearchResultDTOFromJSON(json['searchResult']),
        'status': json['status'] == null ? undefined : json['status'],
        'itemHeight': json['itemHeight'] == null ? undefined : json['itemHeight'],
        'itemLength': json['itemLength'] == null ? undefined : json['itemLength'],
        'itemWidth': json['itemWidth'] == null ? undefined : json['itemWidth'],
        'itemWeight': json['itemWeight'] == null ? undefined : json['itemWeight'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
        'title': json['title'] == null ? undefined : json['title'],
        'categoryBsr': json['categoryBsr'] == null ? undefined : json['categoryBsr'],
        'subcategoryBsr': json['subcategoryBsr'] == null ? undefined : json['subcategoryBsr'],
        'brand': json['brand'] == null ? undefined : json['brand'],
        'productType': json['productType'] == null ? undefined : json['productType'],
        'reviewRating': json['reviewRating'] == null ? undefined : json['reviewRating'],
        'reviewCount': json['reviewCount'] == null ? undefined : json['reviewCount'],
        'reviewStatus': json['reviewStatus'] == null ? undefined : json['reviewStatus'],
    };
}
export function SearchResultCatalogDTOToJSON(json) {
    return SearchResultCatalogDTOToJSONTyped(json, false);
}
export function SearchResultCatalogDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'createdBy': value['createdBy'],
        'createdDate': value['createdDate'] == null ? undefined : ((value['createdDate']).toISOString()),
        'lastModifiedBy': value['lastModifiedBy'],
        'lastModifiedDate': value['lastModifiedDate'] == null ? undefined : ((value['lastModifiedDate']).toISOString()),
        'id': value['id'],
        'searchResult': SearchResultDTOToJSON(value['searchResult']),
        'status': value['status'],
        'itemHeight': value['itemHeight'],
        'itemLength': value['itemLength'],
        'itemWidth': value['itemWidth'],
        'itemWeight': value['itemWeight'],
        'imageUrl': value['imageUrl'],
        'title': value['title'],
        'categoryBsr': value['categoryBsr'],
        'subcategoryBsr': value['subcategoryBsr'],
        'brand': value['brand'],
        'productType': value['productType'],
        'reviewRating': value['reviewRating'],
        'reviewCount': value['reviewCount'],
        'reviewStatus': value['reviewStatus'],
    };
}
